import React, {ReactElement} from "react";
import {Loader} from "../../components/Loader";
import {Table} from "../../components/Table/Table";
import {Dictionary} from "../../components/Dictionary";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {FormComponent} from "../../components/FormComponent";
import {RightAside} from "../../components/Aside/RightAside";
import {SignTurnRightFill} from "react-bootstrap-icons";
import {SysButton} from "../../components/Elements/SysButton";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {StatusPage} from "../StatusPage";
import {Util} from "../../components/Util";
import {DateTime} from "../../components/ListComponent/DateTime";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";

export class ShipmentDetails extends FormComponent {
    protected dictionary: Dictionary = new Dictionary();

    componentDidMount() {
        if (this.user.hasRight('shipment/details') === false && this.user.hasRight('shipment/edit') === false) {
            return;
        }
        let [section, id] = window.location.pathname.split('/').filter((v: string) => {
            return 0 < v.length
        }).slice(2);

        if (typeof id === 'undefined') {
            id = section;
            section = '';
        }

        this.request.fetch('/shipment/' + id, null, {method: 'GET'})
            .then((data: { item: { [key: string]: string }, rights: string[] } | any) => {
                if (!(data.item || null)) {
                    this.setState({
                        code: this.request.getResponseStatus() || 400,
                        message: data.message || 'unknown-error'
                    });
                    return;
                }
                this.setState({
                    id: data.id,
                    item: data.item,
                    rights: data.rights,
                    section: section
                });
            }).catch(error => {
            this.onError(error);
        });
    }

    protected onSuccess(data: any, event: React.FormEvent): any {
        if (data.message) {
            (
                (event.target as HTMLElement).querySelector('form .alert.alert-success') as HTMLElement
            ).innerHTML = this.dictionary.get[data.message];
        }
        (
            (event.target as HTMLElement).querySelector('form .alert.alert-success') as HTMLElement
        ).classList.remove('hide');
        RightAside.reload = true;
    }

    synchronizationAction(event: any): void {
        event.preventDefault();
        this.sendOperation(event);
    }

    closeOrderAction(event: any): void {
        event.preventDefault();
        this.sendOperation(event);
    }

    sendOperation(event: any): void {
        if (RightAside.reload) {
            return;
        }
        RightAside.reload = true;
        const element = event.target.closest('div');

        const alertInfo = element.closest('.details').querySelector('.alert.alert-info') as HTMLElement;
        alertInfo.classList.remove('hide');

        const uriPath: string = element.getAttribute('data-target-url').replace('{shipmentId}', this.state?.item.id);

        this.request.fetch(uriPath, null, {
            method: 'POST'
        }).then((data: any) => {
            // RightAside.reload = false;
            alertInfo.classList.add('hide');

            FormComponent.checkMessages(data);

            const alert = element.closest('.details').querySelector('.alert.alert-success') as HTMLElement;

            alert.innerHTML = this.dictionary.get['success-operation'];
            alert.classList.remove('hide');
        }).catch(error => {
            const alert = element.closest('.details').querySelector('.alert.alert-danger') as HTMLElement;
            alert.innerHTML = this.dictionary.get[error.message || 'success-operation'];
            alert.classList.remove('hide');
            console.error(error);
        });
    }

    render() {
        if (this.state?.code && this.state?.message) {
            return <StatusPage code={this.state.code} message={this.state.message}/>;
        }
        if (typeof this.state?.item === 'undefined') {
            return <Loader/>;
        }

        let items: any = [];

        for (let i in this.state?.item.items) {
            let elem = this.state?.item.items[i];
            items.push([
                elem.id + " ",
                elem.reference_id,
                elem.suborder_id,
                elem.product_id ? Util.link(elem.sku, '/product/details/' + elem.product_id) : elem.sku,
                elem.name,
                <FormattedNumber value={elem.quantity} suffix={this.dictionary.get['pc']}/>,
                <FormattedNumber value={elem.quantity_shipped} suffix={this.dictionary.get['pc']}/>,
                <FormattedNumber value={elem.quantity_diff} suffix={this.dictionary.get['pc']}/>,
            ]);
        }
        const synchronizationAction = (e: any) => {
            this.synchronizationAction(e);
        };
        const closeOrderAction = (e: any) => {
            this.closeOrderAction(e);
        };

        const saveUrl = "/shipment/" + this.state.item.id;

        return (
            <div className="x-form">

                <input type="hidden" name="id" defaultValue={this.state?.item.id || ''}/>

                <div className="row gx-4">
                    {this.state?.item.nfo &&
                        <div className="col-md-12 details">
                            <div className={Util.alertTypeByStatus(this.state.item.status)} role="alert">
                                {this.state?.item.nfo}
                            </div>
                        </div>
                    }

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>
                            {this.dictionary.get['shipment-details']}
                            {this.isEditable(true) && <SysButton onClick={this.editDetails} type={'PencilFill'}
                                                                 text={this.dictionary.get['edit']}/>}
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                {this.getDetails(false)}
                            </table>
                        </div>
                        {this.isEditable(true) && <div className="hidden">
                            <form onSubmit={this.handleSubmit} action={saveUrl} method="PATCH" id="edit-details"
                                  className="hidden details">

                                <h6>
                                    {this.dictionary.get['edit-shipment-details']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                </h6>

                                <div className="table-responsive">
                                    <table className="table table-sm align-middle inlineTable">
                                        {this.getDetails(true)}
                                    </table>
                                </div>

                                <FormSubmit aside={true}/>
                            </form>
                        </div>}
                    </div>

                    <div className="col-md-12 col-lg-6 col-xl-4 details">
                        <h6>{this.dictionary.get['fulfillment-info']}
                            {this.hasOperations() &&
                                <SysButton onClick={this.openOperations} type={'AirplaneFill'}
                                           className="lowercase"
                                           text={this.dictionary.get['operations']}/>}</h6>

                        <div className="table-responsive">
                            <table className="table table-sm align-middle inlineTable">
                                <Table.TBody {...{
                                    data: [
                                        [this.dictionary.get['created_at'], DateTime.create({
                                            value: this.state?.item.created_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['imported_at'], DateTime.create({
                                            value: this.state?.item.imported_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['sync_at'], DateTime.create({
                                            value: this.state?.item.sync_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['closed_at'], DateTime.create({
                                            value: this.state?.item.closed_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['cancelled_at'], DateTime.create({
                                            value: this.state?.item.cancelled_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['updated_by'], this.state?.item.updated_by || ''],
                                        [this.dictionary.get['updated_at'], DateTime.create({
                                            value: this.state?.item.updated_at || '',
                                            inline: true
                                        })],
                                        [this.dictionary.get['manifest_no'], this.state?.item.manifest_no || ''],
                                        [this.dictionary.get['manifest_date'], DateTime.create({
                                            value: this.state?.item.manifest_date || '',
                                            inline: true
                                        })],
                                    ]
                                }}/>
                            </table>
                        </div>
                        {this.hasOperations() && <div className="hidden">
                            <div id="open-operations" className="hidden details">
                                <h6>
                                    {this.dictionary.get['operations']}
                                    <SignTurnRightFill className="closeRightAside" onClick={RightAside.close}/>
                                    <br/>&nbsp;
                                </h6>
                                <div className="table-responsive">
                                    <table className="table table-sm align-middle wideRight">
                                        <tbody>
                                        {this.state?.item.status === 'in-transit' && <tr>
                                            <td>
                                                <SysButton type={'SignTurnRightFill'}
                                                           text={this.state?.item.fulfillment_service_name + ' - ' + this.dictionary.get['synchronization']}
                                                           onClick={synchronizationAction}
                                                           data-target-url="/shipment/synchronization/{shipmentId}"/>
                                            </td>
                                            <td style={{fontWeight: 'normal'}}>
                                                {this.dictionary.get['synchronization-info']}
                                            </td>
                                        </tr>}
                                        {this.state?.item.status === 'close-error' && <tr>
                                            <td colSpan={2}>
                                                <SysButton type={'SignTurnRightFill'}
                                                           text={this.state?.item.service_name + ' - ' + this.dictionary.get['close-order']}
                                                           onClick={closeOrderAction}
                                                           data-target-url="/shipment/closeShipment/{shipmentId}"/>
                                            </td>
                                        </tr>}
                                        </tbody>
                                    </table>
                                </div>
                                <FormSubmit aside={true} nosubmit={true}/>
                            </div>
                        </div>}
                    </div>

                    <div className="col-12">
                        <h6>
                            {this.dictionary.get['shipment-items']} - ({items.length} {this.dictionary.get['pc']})
                        </h6>

                        <div className="table-responsive">
                            <table className="table table-hover table-sm align-middle">
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>{this.dictionary.get['reference_id']}</th>
                                    <th>{this.dictionary.get['fulfillment_id']}</th>
                                    <th>{this.dictionary.get['sku']}</th>
                                    <th>{this.dictionary.get['name']}</th>
                                    <th>{this.dictionary.get['quantity']}</th>
                                    <th>{this.dictionary.get['quantity_shipped']}</th>
                                    <th>{this.dictionary.get['quantity_diff']}</th>
                                </tr>
                                </thead>
                                <Table.TBody {...{data: items}}/>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    private hasOperations(): boolean {
        if (this.user.hasRight('shipment/edit') === false) {
            return false;
        }
        switch (this.state?.item.status) {
            case 'in-transit':
            case 'close-error':
                return true;
            default:
                return false;
        }
    }

    private isEditable(onlyRights: boolean = false): boolean {
        if (this.user.hasRight('shipment/edit') === false) {
            return false;
        }
        if (onlyRights) {
            return true;
        }
        switch (this.state?.item.status) {
            case 'draft':
            case 'scheduled':
            case 'open':
            case 'b2b-open':
            case 'cancelled':
            case 'address-error':
            case 'unknown-product':
            case 'duplication-error':
            case 'customer-error':
            case 'on-hold':
                return true;
        }
        return false;
    }

    private getStatus(input: boolean, status: any): ReactElement {
        if (!input || ['address-error', 'completed'].indexOf(status) !== -1) {
            return Util.status(status, {tooltip: this.dictionary.get[status + '-info']});
        }
        let statusList: string[];
        switch (status) {
            case 'draft':
            case 'scheduled':
            case 'open':
            case 'b2b-open':
            case 'cancelled':
            case 'unknown-product':
            case 'insufficient-quantity':
            case 'duplication-error':
            case 'customer-error':
            case 'on-hold':
                statusList = ['draft', 'scheduled', 'open', 'b2b-open', 'cancelled', 'duplication-error', 'unknown-product', 'customer-error', 'on-hold'];
                break;
            case 'in-transit':
            case 'b2b-in-transit':
                statusList = ['draft', 'scheduled', 'open', 'b2b-open', 'cancelled', 'duplication-error', 'unknown-product', 'on-hold', 'in-transit', 'b2b-in-transit'];
                break;
            case 'closed':
            case 'close-error':
                statusList = ['closed', 'close-error']
                break;
            // case 'error':
            default:
                statusList = ['draft', 'scheduled', 'open', 'b2b-open', 'cancelled', 'duplication-error', 'unknown-product', 'on-hold', 'in-transit', 'b2b-in-transit', 'error', 'completed', 'closed', 'close-error'];
        }

        return (
            <FormGroup.Select {...{
                id: 'status',
                skipLabel: true,
                basic: 'please-select',
                items: statusList,
                defaultValue: status
            }}/>
        );
    }

    private getType(input: boolean, type: any): ReactElement {
        if (!input || !this.isEditable() || ['draft'].indexOf(this.state?.item.status) === -1) {
            return type;
        }
        return (
            <FormGroup.Select {...{
                id: 'type',
                skipLabel: true,
                basic: 'please-select',
                items: ['B2C', 'B2B'],
                defaultValue: type
            }}/>
        );
    }

    private getInput(input: boolean, id: string, value: any): ReactElement {
        if (!input || !this.isEditable()) {
            return value;
        }
        if (value && React.isValidElement(value)) {
            value = (value as ReactElement).props.children as string;
        }
        return (
            <FormGroup.Input {...{skipLabel: true, id: id, defaultValue: value}}/>
        );
    }

    private getDetails(input: boolean): ReactElement {
        return (
            <Table.TBody {...{
                data: [
                    [this.dictionary.get['origin'], this.state?.item.service_name || ''],
                    [this.dictionary.get['fulfiller'], this.state?.item.fulfillment_service_name || ''],
                    [this.dictionary.get['id'], Util.copyCell(this.state?.item.id || '')],
                    [this.dictionary.get['reference_id'], this.getInput(input, 'reference_id', Util.copyCell(this.state?.item.reference_id || ''))],
                    [this.dictionary.get['warehouse_code'], this.getInput(input, 'warehouse_code', Util.copyCell(this.state?.item.warehouse_code || ''))],
                    [this.dictionary.get['queue_id'], this.getInput(input, 'queue_id', Util.copyCell(this.state?.item.queue_id || ''))],
                    [this.dictionary.get['fulfillment_id'], this.getInput(input, 'fulfillment_id', Util.copyCell(this.state?.item.fulfillment_id || ''))],
                    [this.dictionary.get['status'], this.getStatus(input, this.state?.item.status)],
                ]
            }}/>
        );
    }

    private openOperations(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#open-operations') as HTMLElement);
    }

    private editDetails(e: any): void {
        e.preventDefault();
        RightAside.open(document.querySelector('#edit-details') as HTMLElement);
    }
}
